// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"618":"ca366489c7cd3026b1d2","788":"93db888480a5805836bb"}[chunkId] + ".js";
};